export const articleConstants = {
  FILTER_ARTICLES_SUCCESS: 'FILTER_ARTICLES_SUCCESS',
};
